import EditPartnerContainer from "../containers/EditPartnerContainer";

const EditPartnerPage = () => {
  return (
    <EditPartnerContainer />
  );
};

export default EditPartnerPage;
